// test1168
(1168 && 0);
